import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "checkbox"];

  connect() {
    this.syncToggle();
  }

  toggle() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.toggleTarget.checked;
    });
  }

  syncToggle() {
    if (!this.hasToggleTarget) return;

    const checkedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length;
    this.toggleTarget.checked = checkedCount > 0 && checkedCount === this.checkboxTargets.length;
    this.toggleTarget.indeterminate = checkedCount > 0 && checkedCount < this.checkboxTargets.length;
  }
}
